import BaseEvent, { BaseGetEvent, IBaseEvent } from './BaseEvent';

export interface ITinkEvent extends IBaseEvent {
  type: 'tink';
  toJSON(): BaseGetEvent & {
    type: ITinkEvent['type'];
    data: string;
    typeTink: string;
    error: string;
  };
}

export default class TinkEvent extends BaseEvent implements ITinkEvent {
  type = 'tink' as const;

  private data: string;
  private typeTink: string;
  private error: string;

  constructor({
    data,
    typeTink,
    error,
  }: {
    data: string;
    typeTink: string;
    error: string;
  }) {
    super(data);
    this.data = data;
    this.typeTink = typeTink;
    this.error = error;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
      data: this.data,
      typeTink: this.typeTink,
      error: this.error,
    };
  }
}
